import { pgTable, uuid, char, timestamp, smallint, boolean, text, jsonb, bigint } from "drizzle-orm/pg-core";
import { sites, pages } from "./sites";

// type: 0 pageview / 1 scroll / 2 section / 3 click / 4 move / 5 goal / 6 exp
export const EVENT_TYPE = {
  PAGEVIEW: 0,
  SCROLL: 1,
  SECTION: 2,
  CLICK: 3,
  MOVE: 4,
  GOAL: 5,
  EXP: 6,
} as const;

// device: 0 pc / 1 sp / 2 tablet
export const DEVICE_CODE = { PC: 0, SP: 1, TABLET: 2 } as const;

// Actual DDL (migrations/0000_amused_tinkerer.sql) hand-edits this table to
// PARTITION BY RANGE (ts) with a composite (id, ts) primary key, since
// drizzle-kit can't emit native partitioning syntax. This TS definition is
// query-layer only — if you re-run `drizzle-kit generate`, re-apply the
// partitioning edit to the new migration rather than trusting the diff.
export const events = pgTable("events", {
  id: bigint("id", { mode: "number" }).primaryKey().generatedAlwaysAsIdentity(),
  siteId: uuid("site_id").notNull().references(() => sites.id, { onDelete: "cascade" }),
  pageId: uuid("page_id").notNull().references(() => pages.id, { onDelete: "cascade" }),
  ts: timestamp("ts", { withTimezone: true }).notNull(),
  visitorId: char("visitor_id", { length: 16 }).notNull(),
  sessionId: char("session_id", { length: 16 }).notNull(),
  device: smallint("device").notNull(),
  isNewVisitor: boolean("is_new_visitor").notNull(),
  refDomain: text("ref_domain"),
  utm: jsonb("utm"),
  type: smallint("type").notNull(),
  payload: jsonb("payload").notNull(),
});
